var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"bold section-title"},[_vm._v("Empleos")]),_c('MediaCard',{attrs:{"items":_vm.jobs}}),_c('p',{staticClass:"bold section-title"},[_vm._v("Proyectos")]),_c('MediaCard',{attrs:{"items":_vm.projects}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }